<template>
  <header class="site-header mo-left header">
    <!-- Main Header -->
    <div class="sticky-header main-bar-wraper navbar-expand-lg">
      <div class="main-bar clearfix">
        <div class="container clearfix ">
          <!-- Website Logo -->
          <div class="logo-header">
            <router-link :to="'/'" class="logo-dark">
              <img
                src="assets/images/horizontal-logo.png"
                class="img-fluid"
                alt=""
              />
            </router-link>
          </div>
          <!-- Nav Toggle Button -->
          <div class="d-flex justify-content-end align-items-center gap-0 p-0 m-0">
            <div class="small-screen-only justify-content-end">
              <a class="btn btn-primary btn-lg btn-shadow" href="/user/login"
                  >{{ pageContent.login }}</a
                >
            </div>
            <button
            class="navbar-toggler collapsed navicon justify-content-end"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
            
          </button>
        
          </div>
           

          <!-- Extra Nav -->
          <div class="extra-nav">
            <div class="extra-cell">
              <a class="btn btn-primary btn-lg btn-shadow" href="/user/login"
                >{{ pageContent.login }}</a
              >
            </div>
          </div>

          <!-- Search Form -->
          <div class="dz-quik-search on">
            <form action="#">
              <input
                name="search"
                type="text"
                class="form-control"
                :placeholder="pageContent.keyword"
              />
              <span id="quik-search-remove"
                ><i class="fa-solid fa-xmark"></i
              ></span>
            </form>
          </div>

         
          <div
            class="header-nav navbar-collapse collapse justify-content-end"
            id="navbarNavDropdown"
          >
            <div class="logo-header">
              <router-link :to="'/'" class="logo-dark">
                <img
                  src="assets/images/horizontal-logo.png"
                  class="img-fluid"
                  style="height: 80px"
                  alt=""
                />
              </router-link>
            </div>
            <ul class="nav navbar-nav navbar navbar-left">
              <li><router-link :to="'/'">{{ pageContent.home }}</router-link></li>
              <li><router-link :to="'/about-us'">{{ pageContent.about }}</router-link></li>
              <li><router-link :to="'/explore'">{{ pageContent.explore }}</router-link></li>
              <li><router-link :to="'/teach'">{{ pageContent.teach }}</router-link></li>
              <li><router-link :to="'/contact-us'">{{ pageContent.contact_us }}</router-link></li>
              <li class="small-screen-only"><router-link :to="'/user/login'">{{ pageContent.login }}</router-link></li>
              <li class="sub-menu-down">
                <a href="javascript:void(0);" @click="toggleDropdown">
                  <img
                    :src="selectedLanguage.flag"
                    class="img-fluid"
                    style="height: 20px"
                  />
                  {{ selectedLanguage.name }}
                </a>
                <ul v-if="dropdownOpen" class="sub-menu">
                  <li v-for="(lang, key) in languages" :key="key">
                    <a href="javascript:void(0);" @click="setLanguage(key)">
                      <img
                        :src="lang.flag"
                        class="img-fluid"
                        style="height: 20px"
                      />
                      {{ lang.name }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- Main Header End -->
  </header>
</template>

<style>
.header-nav .nav > li > a,
.header li a {
  color: #0c27bd !important;
}

.header-transparent .header-nav .nav > li > a {
  color: #fff !important;
}
@media (min-width: 768px) {
    .small-screen-only {
        display: none !important;
    }
}

</style>

<script>
export default {
  props: {
    pageContent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      page: null,
      dropdownOpen: false,
      selectedLanguage: {
        code: "en",
        name: "English",
        flag: "/assets/images/flags/us.png",
      },
      languages: {
        en: { name: "English", flag: "/assets/images/flags/us.png" },
        es: { name: "Spanish", flag: "/assets/images/flags/spain.png" },
      },
    };
  },
  watch: {
    $route() {
      this.page = this.$route.name;
    },
  },
  mounted() {
    // Load language from localStorage
    const storedLang = localStorage.getItem("language");
    if (storedLang && this.languages[storedLang]) {
      this.selectedLanguage = this.languages[storedLang];
    }
  },
  methods: {
    setLanguage(langCode) {
      this.selectedLanguage = this.languages[langCode];
      localStorage.setItem("language", langCode);
      this.$emit('change_language', langCode);

      this.dropdownOpen = false;
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
  },
};
</script>
